import React from 'react';
import './Loader.scss';

const Loader = () => {
  return (
    <div className="maim-loader">
      <span className="loader"></span>
    </div>
  );
};

export default Loader;